import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "intro",
  class: "intro"
}
const _hoisted_2 = { class: "intro__inner" }
const _hoisted_3 = { class: "intro__bio glass-card" }
const _hoisted_4 = { class: "intro__description" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: "images/josch26.jpeg",
        alt: "Profile Image",
        class: "intro__avatar"
      }, null, -1)),
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "intro__eyebrow" }, "AI Engineer", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "intro__name" }, "Josch Rossa MSc", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.$t("Summary.aboutMe")) + " ", 1),
          _createElementVNode("a", {
            href: _ctx.$t('Summary.propOneLink'),
            class: "intro__link"
          }, _toDisplayString(_ctx.$t("Summary.propOne")), 9, _hoisted_5),
          _cache[0] || (_cache[0] = _createTextVNode("  ", -1)),
          _createElementVNode("a", {
            href: _ctx.$t('Summary.propTwoLink'),
            class: "intro__link"
          }, _toDisplayString(_ctx.$t("Summary.propTwo")), 9, _hoisted_6)
        ])
      ])
    ])
  ]))
}